module.exports = __webpack_public_path__ + "static/media/default.4f340806.png";